<div class="co-ap-pane-header mydocma-detail-header">

  <button mat-flat-button type="button"
          *ngIf="doneVisible && !locked"
          [disabled]="!doneEnabled"
          color="accent"
          (click)="doneClick.emit()">
    <ng-container *ngIf="!continueMode; else continueButton">
      <mat-icon>done</mat-icon>
      {{ 'CO.buttons.save' | translate }}
    </ng-container>
    <ng-template #continueButton>
      {{ 'CO.next.save' | translate }}
      <mat-icon>chevron_right</mat-icon>
    </ng-template>
  </button>

  <mydocma-custom-mat-icon
    style="padding-left: 5px;"
    [iconName]="'lock'"
    *ngIf="locked">
  </mydocma-custom-mat-icon>

  <div class="ap-pane-header-title">
        <span class="ap-pane-header-icon">
            <ng-content select="[ap-pane-header-icon]"></ng-content>
        </span>
    <span class="ap-pane-header-text">{{ headerText }}</span>
  </div>

  <div *ngIf="!locked">
    <ng-content select="[ap-pane-new]"></ng-content>
  </div>

  <div *ngIf="!locked">
    <ng-content select="[ap-pane-menu]"></ng-content>
  </div>

  <button mat-icon-button type="button" (click)="closeClick.emit()">
    <mat-icon>close</mat-icon>
  </button>

</div>
